import FormHeader from "../../components/Other/FormHeader";
import Product from "./Product";

export default function Store() {
    return (
        <>
            <div className="row ">
                <div className="col-12 ">
                    <div className="row gy-4 " >
                        <div className={`col-12 text-center`} >
                            <div className={`mb-2 card formBorderBox text-white bg-light-gray p-2 prl-10`}  >
                                <FormHeader name={'محصولات'}></FormHeader>
                                <Product></Product>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}